<template>
<div>
    <div class="pc">
        <div class="page-right-div">
            <div class="img"><img src="@/assets/newImages/common/page-right-img.png" alt=""></div>
            <div class="one-div flexCenter">
                <div class="one-text  flexCenter">猜你<br>喜欢</div>
                <div class="one-hover flexCenter">
                    <div class="hover-img"><img src="@/assets/newImages/common/page-right-icon1.png" alt=""></div>
                    <p>猜你喜欢</p>
                </div>
                <div class="like-hover">
                    <div class="like-div">
                        <div class="like-title">猜你喜欢</div>
                        <div class="like-main">
                            <div class="likes">
                                <div class="like-one" v-for="(likeOne,likeOneIndex) in likeLists" :key="likeOneIndex">
                                    <div class="like-one-title"><img src="@/assets/newImages/common/line.png" alt=""><p>{{likeOne.likeOneTitle}}</p></div>
                                    <div class="like-content">
                                        <div class="like-content-one" @click="clickLike(likeCont, likeOneIndex)" v-if="likeOne.likeOneTitle=='议程'" v-for="(likeCont,index) in likeOne.likeContent" :key="index">
                                            <div class="title"><div class="sanjiao"></div><p>{{likeCont.categoryArr[0]}}</p></div>
                                            <div class="text">{{likeCont.name}}</div>
                                        </div>
                                        <div class="like-content-two" @click="clickLike(likeCont, likeOneIndex)" v-if="likeOne.likeOneTitle=='展厅'" v-for="(likeCont,index) in likeOne.likeContent" :key="index">
                                            <div class="img-bg"><img :src="likeCont.coverImageRealPath" alt=""></div>
                                            <div class="text">{{likeCont.title}}</div>
                                            <div class="text-bg"></div>
                                        </div>
                                        <div class="like-content-three" @click="clickLike(likeCont, likeOneIndex)" v-if="likeOne.likeOneTitle=='资料'" v-for="(likeCont,index) in likeOne.likeContent" :key="index">
                                            <div class="img"><img src="@/assets/newImages/common/like-img3-icon.png" alt=""></div>
                                            <div class="text">{{likeCont.name}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="one-div flexCenter" @click="clickOnlineHall">
                <div class="one-text flexCenter">线上<br>展厅</div>
                <div class="one-hover flexCenter">
                    <div class="hover-img"><img src="@/assets/newImages/common/page-right-icon2.png" alt=""></div>
                    <p>线上展厅</p>
                </div>
            </div>
            <div class="one-div flexCenter" @click="clickRightCantactUs">
                <div class="one-text flexCenter">项目<br>咨询</div>
                <div class="one-hover flexCenter">
                    <div class="hover-img"><img src="@/assets/newImages/common/page-right-icon3.png" alt=""></div>
                    <p>项目咨询</p>
                </div>
            </div>
        </div>
        <div class="cover-page flexCenter" v-if="pageCover" @touchmove.prevent @mousewheel.prevent>
            <div class="cover-main">
                <div class="cover-close" @click="closePageCover()"><img src="@/assets/newImages/home/cover-close.png" alt=""></div>
                <div class="cover-content">
                    <div class="cover-one" @click="clickFeedback()"><img src="@/assets/newImages/home/cover-icon1.png" alt=""><p>反馈需求</p></div>
                    <div class="cover-one" @click="clickConsult()"><img src="@/assets/newImages/home/cover-icon2.png" alt=""><p>产品&方案咨询</p></div>
                </div>
                <div class="text">会务咨询：+86 0755-28565555</div>
            </div>
        </div>
    </div>
    <div class="mobile">
        <div class="page-right-div">
            <div class="img"><img src="@/assets/newImages/common/page-right-img.png" alt=""></div>
            <div class="one-div flexCenter" @click="clickLikeOne()" :class="{'one-div-active':wapGuessLikeShow==true}">
                <div class="one-text">猜你<br>喜欢</div>
                <div class="one-hover">
                    <div class="text">猜你<br>喜欢</div>
                </div>
                <div class="like-hover" id="guess-container">
                    <div class="like-div">
                        <div class="like-title">猜你喜欢</div>
                        <div class="like-main">
                            <div class="likes">
                                <div class="like-one" v-for="(likeOne,likeOneIndex) in likeLists" :key="likeOneIndex">
                                    <div class="like-one-title"><img src="@/assets/newImages/common/line.png" alt=""><p>{{likeOne.likeOneTitle}}</p></div>
                                    <div class="like-content">
                                        <div class="like-content-one" @click.stop="clickLike(likeCont, likeOneIndex)"  v-if="likeOne.likeOneTitle=='议程'" v-for="(likeCont,index) in likeOne.likeContent" :key="index">
                                            <div class="title"><div class="sanjiao"></div><p>{{likeCont.categoryArr[0]}}</p></div>
                                            <div class="text">{{likeCont.name}}</div>
                                        </div>
                                        <div class="like-content-two" @click.stop="clickLike(likeCont, likeOneIndex)"  v-if="likeOne.likeOneTitle=='展厅'" v-for="(likeCont,index) in likeOne.likeContent" :key="index">
                                            <div class="img-bg"><img :src="likeCont.coverImageRealPath" alt=""></div>
                                            <div class="text">{{likeCont.title}}</div>
                                            <div class="text-bg"></div>
                                        </div>
                                        <div class="like-content-three" @click.stop="clickLike(likeCont, likeOneIndex)" v-if="likeOne.likeOneTitle=='资料'" v-for="(likeCont,index) in likeOne.likeContent" :key="index">
                                            <div class="img"><img src="@/assets/newImages/common/like-img3-icon.png" alt=""></div>
                                            <div class="text">{{likeCont.name}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="one-div flexCenter" @click="clickOnlineHall">
                <div class="one-text">线上<br>展厅</div>
                <div class="one-hover">
                    <div class="text">线上<br>展厅</div>
                </div>
            </div>
            <div class="one-div flexCenter" @click="clickRightCantactUs">
                <div class="one-text">项目<br>咨询</div>
                <div class="one-hover">
                    <div class="text">项目<br>咨询</div>
                </div>
            </div>
        </div>
        <div class="cover-page" v-if="pageCover" @touchmove.prevent @mousewheel.prevent>
            <div class="cover-main">
                <div class="cover-close" @click="closePageCover()"><img src="@/assets/newImages/home/cover-close.png" alt=""></div>
                <div class="cover-content">
                    <div class="cover-one" @click="clickFeedback()"><img src="@/assets/newImages/home/cover-icon1.png" alt=""><p>反馈需求</p></div>
                    <div class="cover-one" @click="clickConsult()"><img src="@/assets/newImages/home/cover-icon2.png" alt=""><p>产品&方案咨询</p></div>
                </div>
                <div class="text">会务咨询：+86 0755-28565555</div>
            </div>
        </div>
        <div class="like-cover" v-if="wapGuessLikeShow" @touchmove.prevent @mousewheel.prevent  @click="clickWapGuessLikeMask()"></div>
    </div>
</div>
</template>

<script>
export default {
    props:{
        likeLists: {
            default:[]
        },
        pageCover:{
            default:false
        }
    },
    data(){
        return{
            pageLikeShow:false
        }
    },
    computed:{
            wapGuessLikeShow(){
                return this.$store.state.wapGuessLikeShow;
            },
        },
    methods:{
        closePageCover(){
            this.$emit('closePageCover')
        },
        clickLike(item,key){
            this.$store.commit('setWapGuessLikeShow', false);
            this.$emit('clickLike', item,key)
        },
        clickOnlineHall(){
            // 埋码
            this.$maima.exhibition_tab_click();

            window.location.href = window.$config.url.onlineHall;
        },
        clickRightCantactUs(){
            this.$emit('clickRightCantactUs')
        },
        clickLikeOne(){
            // this.pageLikeShow=true
            this.$store.commit('setWapGuessLikeShow', true);
            // 埋码
            this.$maima.recommendation_tab_click();
        },
        clickFeedback(){
            window.open(window.$config.url.feedback);

            // 埋码
            this.$maima.index_feedback_btn_click();
        },
        clickConsult(){
            window.open(window.$config.url.consult);

            // 埋码
            this.$maima.index_consultation_btn_click();
        },
        clickWapGuessLikeMask(){
            this.$store.commit('setWapGuessLikeShow', false);
        },
    }
}
</script>

<style scoped lang="scss">
*{
    box-sizing: border-box;
    padding: 0;
    margin: 0;
}
.pc {
    .page-right-div{
        position: fixed;
        right: 0;
        bottom: 25vh;
        width: pxToVw(68);
        height: pxToVw(257);
        background: #FFFFFF;
        z-index: 999;
        box-shadow: 0 0 pxToVw(27) 0 rgba(231,231,231,0.5);
        border-radius: pxToVw(6) 0 0 0;
        padding-top: pxToVw(16);
        border-bottom: pxToVw(4) solid #C50819;
        .img{
            position: absolute;
            top: pxToVw(-40);right: 0;
            width: pxToVw(93);
            height: pxToVw(79);
            img{
                vertical-align: top;
                width: 100%;
            }
        }
        .one-div{
            position: relative;
            width: pxToVw(68);
            height: pxToVw(80);
            border-bottom: pxToVw(1) solid #D8D8D8;
            &:hover{
                background: #C50819;
                box-shadow: 0 0 pxToVw(27) 0 rgba(231,231,231,0.5);
                .one-text{display: none;}
                .one-hover{display: block;}
                .like-hover{display: block;}
            }
            &:last-child{
                border-bottom: none;
            }
            .one-text{
                width: pxToVw(68);
                height: pxToVw(80);
                cursor: pointer;
                font-size: pxToVw(19);
                color: #666666;
                line-height: pxToVw(23);
                text-shadow:  0 0 pxToVw(27) rgba(231, 231, 231, 0.5);
            }
            .one-hover{
                display: none;
                flex-direction: column;
                cursor: pointer;
                .hover-img{
                    margin: 0 auto;
                    width: pxToVw(26);
                    height: pxToVw(22);
                    margin-bottom: pxToVw(10);
                    img{
                        width: 100%;
                        vertical-align: top;
                    }
                }
                p{
                    font-size: pxToVw(13);
                    color: #FFFFFF;
                    line-height: pxToVw(16);
                    text-align: center;
                    text-shadow: 0 0 pxToVw(27) rgba(231, 231, 231, 0.5);
                }
            }
            .like-hover{
                display: none;
                position: absolute;
                top:0;right: pxToVw(68);
                // width: pxToVw(1267);
                width: auto;
                max-width: pxToVw(1800);
                height: pxToVw(315);
                padding-right: pxToVw(7);
                .like-div{
                    // width: pxToVw(1260);
                    width: auto;
                    height: pxToVw(315);
                    background: #FFFFFF;
                    box-shadow: 0 0 pxToVw(27) 0 rgba(231,231,231,0.5);
                    border-radius: pxToVw(3);
                    border-radius: pxToVw(3);
                    border-radius: pxToVw(3);
                    padding: 0 pxToVw(32) 0 pxToVw(45);
                    .like-title{
                        // width: pxToVw(1182);
                        width: auto;
                        height: pxToVw(72);
                        padding-top: pxToVw(32);
                        font-size: pxToVw(24);
                        font-family: "FZLT-blackBold";
                        color: #C50819;
                        line-height: pxToVw(28);
                        border-bottom: pxToVw(1) solid #D8D8D8;
                    }
                    .like-main{
                        // width: pxToVw(1182);
                        width: auto;
                        height: pxToVw(240);
                        padding: pxToVw(24) 0 0;
                        overflow-x: scroll;
                        scrollbar-width: none;
                        -ms-overflow-style: none;
                        &::-webkit-scrollbar{
                            width: 0;
                        }
                        .likes{
                            // width: 200%;
                            height: 100%;
                            display: flex;
                            align-items: center;
                        }
                        .like-one{
                            display: inline-block;
                            width: auto;
                            height: pxToVw(177);
                            margin-right: pxToVw(20);
                            cursor: pointer;
                            &:last-child{
                                margin-right: 0;
                            }
                            .like-one-title{
                                padding-left: pxToVw(1);
                                display: flex;
                                align-items: center;
                                height: pxToVw(23);
                                margin-bottom: pxToVw(10);
                                img{
                                    width: pxToVw(11);
                                    height: pxToVw(11);
                                    vertical-align: top;
                                    margin: pxToVw(-2) pxToVw(12) 0 0;
                                }
                                p{
                                    font-size: pxToVw(19);
                                    color: #333333;
                                    line-height: pxToVw(23);
                                }
                            }
                            .like-content{
                                height: pxToVw(144);
                                display: flex;
                                .like-content-one{
                                    width: pxToVw(205);
                                    height: pxToVw(144);
                                    padding: pxToVw(13) 0 0 pxToVw(17);
                                    margin-right: pxToVw(10);
                                    background: url(../assets/newImages/common/like-img1.png) no-repeat center center/cover;
                                    &:last-child{
                                        margin-right: 0;
                                    }
                                    .title{
                                        height: 20px;
                                        display: flex;
                                        align-items: center;
                                        margin-bottom: pxToVw(24);
                                        .sanjiao{
                                            width: 0;
                                            height: 0;
                                            border-top: pxToVw(5) solid #FFF;
                                            border-left: pxToVw(5) solid transparent;
                                            transform: rotate(45deg);
                                            margin-right: pxToVw(12);
                                        }
                                        p{
                                            font-size: pxToVw(17);
                                            font-family: "FZLT-blackLittle";
                                            color: #FFFFFF;
                                            line-height: pxToVw(20);
                                        }
                                    }
                                    .text{
                                        width: pxToVw(177);
                                        height: pxToVw(56);
                                        font-size: pxToVw(19);
                                        color: #FFFFFF;
                                        line-height: pxToVw(28);
                                        overflow: hidden;
                                        display: -webkit-box;
                                        -webkit-line-clamp: 2;
                                        -webkit-box-orient: vertical;
                                        text-overflow :ellipsis; 
                                    }
                                }
                                .like-content-two{
                                    width: pxToVw(256);
                                    height: pxToVw(144);
                                    z-index: 3;
                                    padding: pxToVw(111) pxToVw(17) 0;
                                    margin-right: pxToVw(10);
                                    position: relative;
                                    // background: url(../assets/newImages/exhibitionGuide/img.png) no-repeat center center/cover;
                                    .text{
                                        font-size: pxToVw(19);
                                        color: #FFFFFF;
                                        line-height: pxToVw(23);
                                        overflow: hidden;
                                        text-overflow :ellipsis; 
                                        white-space: nowrap; 
                                    }
                                    .img-bg{
                                        position: absolute;
                                        z-index: -2;
                                        width: 100%;
                                        height: 100%;top: 0;left: 0;
                                        img{
                                            width: 100%;
                                            height: 100%;
                                            vertical-align: top;
                                        }
                                    }
                                    .text-bg{
                                        position: absolute;
                                        z-index: -1;bottom: 0;
                                        left: 0;
                                        width: 100%;
                                        height: pxToVw(50);
                                        background: linear-gradient(180deg, rgba(118, 53, 53, 0) 0%, #000000 100%);
                                    }
                                }
                                .like-content-three{
                                    position: relative;
                                    width: pxToVw(256);
                                    height: pxToVw(144);
                                    padding: pxToVw(72)0 0;
                                    margin-right: pxToVw(10);
                                    background: url(../assets/newImages/common/like-img3.png) no-repeat center center/cover;
                                    .img{
                                        position: absolute;
                                        top:pxToVw(37);left: pxToVw(100);
                                        width: pxToVw(57);
                                        height: pxToVw(45);
                                        img{
                                            vertical-align: top;
                                            width: 100%;
                                        }
                                    }
                                    .text{
                                        height: pxToVw(72);
                                        padding: pxToVw(39) pxToVw(17) 0;
                                        background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0,0,0,0.6) 100%);
                                        border-radius: pxToVw(3);
                                        font-size: pxToVw(19);
                                        color: #FFFFFF;
                                        line-height: pxToVw(23);
                                        overflow: hidden;
                                        text-overflow :ellipsis; 
                                        white-space: nowrap; 
                                    }
                                }
                            }
                        }
                    }
                }
            } 
        }
    }
    .cover-page{
        position: fixed;
        z-index: 1000;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0,0,0,0.5);
        border-radius: 4px;
        .cover-main{
            width: pxToVw(549);
            height: pxToVw(344);
            background: #FFFFFF;
            border-radius: pxToVw(9);
            .cover-close{
                float: right;
                width: pxToVw(62);
                cursor: pointer;
                height: pxToVw(62);
                padding: pxToVw(24) pxToVw(24) pxToVw(19) pxToVw(19);
                img{
                    width: pxToVw(19);
                    height: pxToVw(19);
                }
            }
            .cover-content{
                width: 100%;
                height: auto;
                display: flex;
                justify-content: space-between;
                padding: 0 pxToVw(86) pxToVw(44);
                border-bottom: 1px solid #EEEEEE;
                .cover-one{
                    width: pxToVw(180);
                    height: pxToVw(160);
                    background: #FFFFFF;
                    padding: pxToVw(35) 0 pxToVw(29);
                    display: flex;
                    flex-direction: column;
                    cursor: pointer;
                    align-items: center;
                    justify-content: space-between;
                    box-shadow: 0px 0px pxToVw(12) 0px rgba(211,211,211,0.5);
                    border-radius: pxToVw(5);
                    img{    
                        width: pxToVw(44);
                        height: pxToVw(45);
                    }
                    p{
                        font-size: pxToVw(19);
                        color: #333333;
                        line-height: pxToVw(24);
                    }
                }
            }
            .text{
                margin-top: pxToVw(27);
                font-size: pxToVw(19);
                font-family: "FZLT-blackBold";
                color: #C50819;
                text-align: center;
                line-height: pxToVw(24);
            }
        }
    }
}
.mobile{
    display: none;
}
@media screen and (max-width:767px) {
    .pc{
        display: none;
    }
    .mobile{
        display: block;
        .page-right-div{
            position: fixed;
            right: 0;
            bottom: 20vh;
            width: 12.2vw;
            height:46.3vw;
            background: #FFFFFF;
            z-index: 8;
            box-shadow: 0 0 4.8vw 0 rgba(231,231,231,0.5);
            border-radius: 1.1vw 0 0 0;
            padding-top: 3.1vw;
            border-bottom: 1vw solid #C50819;
            .img{
                position: absolute;
                top: -6.2vw;right: 0;
                width: 16.9vw;
                height: 14vw;
                img{
                    vertical-align: top;
                    width: 100%;
                }
            }
            .one-div{
                position: relative;
                width: 12.2vw;
                height: 14.4vw;
                border-bottom: 1px solid #D8D8D8;
                &:last-child{
                    border-bottom: none;
                }
                .one-text{
                    font-size: 3.2vw;
                    color: #666666;
                    line-height: 3.6vw;
                    text-shadow:  0 0 4.8vw rgba(231, 231, 231, 0.5);
                }
                .one-hover{
                    display: none;
                    .text{
                        font-size: 3.2vw;
                        color: #FFFFFF;
                        line-height: 3.6vw;
                        text-align: center;
                        text-shadow: 0 0 4.8vw rgba(231, 231, 231, 0.5);
                    }
                }
                .like-hover{
                    display: none;
                    position: absolute;
                    top:0;right: 12.3vw;
                    width: 50.9vw;
                    // height: 150.1vw;
                    height: 75vw;
                    overflow-y: scroll;
                    &::-webkit-scrollbar{
                            width: 0;
                        }
                    .like-div{
                        width: 50.9vw;
                        // height: 150.1vw;
                        height: auto;
                        background: #FFFFFF;
                        box-shadow: 0 0 2.7vw 0 rgba(231,231,231,0.5);
                        border-radius: 0.3vw;
                        padding: 0 4.5vw 0;
                        .like-title{
                            width: 41.9vw;
                            height: 10.1vw;
                            padding-top: 4.1vw;
                            font-size: 3.5vw;
                            font-family: "FZLT-blackBold";
                            color: #C50819;
                            line-height: 4.1vw;
                            border-bottom: 0.1vw solid #D8D8D8;
                        }
                        .like-main{
                            width: 41.9vw;
                            // height: 150.1vw;
                            height: auto;
                            padding: 2.4vw 0 5.3vw;
                            .likes{
                                // width: 200%;
                                // height: 100%;
                                height: auto;
                                display: flex;
                                // align-items: center;
                                flex-direction: column;
                            }
                            .like-one{
                                display: inline-block;
                                width: auto;
                                // height: pxToVw(177);
                                height: auto;
                                margin-bottom: 3.9vw;
                                cursor: pointer;
                                &:last-child{
                                    margin-bottom: 0;
                                }
                                .like-one-title{
                                    padding-left: pxToVw(1);
                                    display: flex;
                                    align-items: center;
                                    height: 3.2vw;
                                    margin-bottom: 2vw;
                                    img{
                                        width: 1.6vw;
                                        height: 1.6vw;
                                        vertical-align: top;
                                        margin: 0 1vw 0 0;
                                    }
                                    p{
                                        font-size: 2.8vw;
                                        color: #333333;
                                        line-height: 3.2vw;
                                    }
                                }
                                .like-content{
                                    // height: pxToVw(144);
                                    height: auto;
                                    .like-content-one{
                                        width: 41.9vw;
                                        height: 20vw;
                                        padding: 0.8vw 0 0 4.4vw;
                                        margin-bottom: 1vw;
                                        background: url(../assets/newImages/common/like-img1.png) no-repeat center center/cover;
                                        &:last-child{
                                            margin-right: 0;
                                        }
                                        .title{
                                            height: 2.9vw;
                                            display: flex;
                                            align-items: center;
                                            margin-bottom: 2.4vw;
                                            .sanjiao{
                                                width: 0;
                                                height: 0;
                                                border-top: 1vw solid #FFF;
                                                border-left: 1.2vw solid transparent;
                                                transform: rotate(45deg);
                                                margin-right: 1.2vw;
                                            }
                                            p{
                                                font-size: 2.5vw;
                                                font-family: "FZLT-blackLittle";
                                                color: #FFFFFF;
                                                line-height: 2.9vw;
                                            }
                                        }
                                        .text{
                                            width: 34.5vw;
                                            height: 9.6vw;
                                            font-size: 3.2vw;
                                            color: #FFFFFF;
                                            line-height: 4.8vw;
                                            overflow: hidden;
                                            display: -webkit-box;
                                            -webkit-line-clamp: 2;
                                            -webkit-box-orient: vertical;
                                            text-overflow :ellipsis; 
                                        }
                                    }
                                    .like-content-two{
                                        width: 41.9vw;
                                        height: 23.7vw;
                                        padding: 17.5vw 0 0 2.8vw;
                                        position: relative;
                                        z-index: 3;
                                        margin-bottom: 1vw;
                                        // background: url(../assets/newImages/exhibitionGuide/img.png) no-repeat center center/cover;
                                        .text{
                                            font-size: 3.2vw;
                                            color: #FFFFFF;
                                            line-height: 3.6vw;
                                            overflow: hidden;
                                            text-overflow :ellipsis; 
                                            white-space: nowrap; 
                                        }
                                        .img-bg{
                                            position: absolute;
                                            z-index: -2;
                                            width: 100%;
                                            height: 100%;top: 0;left: 0;
                                            img{
                                                width: 100%;
                                                height: 100%;
                                                vertical-align: top;
                                            }
                                        }
                                        .text-bg{
                                            position: absolute;
                                            z-index: -1;bottom: 0;
                                            left: 0;
                                            width: 100%;
                                            height: 8.5vw;
                                            background: linear-gradient(180deg, rgba(118, 53, 53, 0) 0%, #000000 100%);
                                        }
                                    }
                                    .like-content-three{
                                        position: relative;
                                        width: 41.9vw;
                                        height: 23.6vw;
                                        padding: 11.7vw 0 0;
                                        background: url(../assets/newImages/common/like-img3.png) no-repeat center center/cover;
                                        .img{
                                            position: absolute;
                                            top:6vw;left: 16.3vw;
                                            width: 9.6vw;
                                            height: 7.6vw;
                                            img{
                                                vertical-align: top;
                                                width: 100%;
                                            }
                                        }
                                        .text{
                                            height: 11.7vw;
                                            padding: 5.6vw 0 0 2.8vw;
                                            background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0,0,0,0.6) 100%);
                                            border-radius: 0.4vw;
                                            font-size: 3.2vw;
                                            color: #FFFFFF;
                                            line-height: 3.6vw;
                                            overflow: hidden;
                                            text-overflow :ellipsis; 
                                            white-space: nowrap; 
                                        }
                                    }
                                }
                            }
                        }
                    }
                } 
            }
            .one-div-active{
                background: #C50819;
                box-shadow: 0 0 4.8vw 0 rgba(231,231,231,0.5);
                .one-text{display: none;}
                .one-hover{display: block;}
                .like-hover{display: block;}
            }
        }
        .cover-page{
            position: fixed;
            z-index: 1000;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            background: rgba(0,0,0,0.5);
            border-radius: 4px;
            .cover-main{
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 82.4vw;
                height: 54.9vw;
                background: #FFFFFF;
                border-radius: 1.3vw;
                // padding: 3vw 3.6vw 0 7.5vw;
                .cover-close{
                    float: right;
                    // width: 2.8vw;
                    // height: 2.9vw;
                    padding: 3vw 3.6vw 0 0;
                    img{
                        width: 2.8vw;
                        height: 2.9vw;
                    }
                }
                .cover-content{
                    width: 82.4vw;
                    height: 35.3vw;
                    display: flex;
                    justify-content: space-between;
                    border-bottom: 2px solid #EEEEEE;
                    padding:3.5vw 7.5vw 0;
                    .cover-one{
                        width: 32vw;
                        height: 25.5vw;
                        background: #FFFFFF;
                        box-shadow: 0px 0px 19px 0px rgba(211,211,211,0.5);
                        border-radius: 0.8vw;
                        padding-top: 5.5vw;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        img{    
                            width: 6.5vw;
                            height: 7.2vw;
                        &:nth-child(2){
                            width: 6.5vw;
                            height: 5.9vw;
                        }
                        }
                        
                        p{
                            font-size: 3.2vw;
                            font-weight: normal;
                            color: #333333;
                            line-height: 10vw;
                        }
                    }
                }
                .text{
                    margin-top: 4.5vw;
                    font-size: 3.2vw;
                    font-weight: normal;
                    color: #C50819;
                    line-height: 3.7vw;
                    font-family: "FZLT-blackBold";
                    text-align: center;
                }
            }
        }
        .like-cover{
            position: fixed;
            z-index: 7;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            // background: rgba(0,0,0,0.5);
            background: rgba(255,255,255,0);
        }
    }
}
</style>